<template>
  <TelemetryCard :title="title" :theme="theme" class="telemetry-card">
    <TelemetryChartWind
      class="chart-component"
      :producer_ids="producerIds"
      :tickPositionsPower="tickPositions"
    />
  </TelemetryCard>
</template>

<script>
import TelemetryCard from './TelemetryCard.vue'
import TelemetryChartWind from "@/components/TelemetryChartWind"

export default {
  name: 'WindChartCard',
  components: {
    TelemetryCard,
    TelemetryChartWind
  },
  props: {
    title: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      default: 'primary'
    },
    producerIds: {
      type: Array,
      required: true
    },
    tickPositions: {
      type: Array,
      default: () => [0, 0.5, 1, 1.5, 2]
    }
  }
}
</script>

<style scoped>
.chart-component {
  width: 100%;
  height: 100%;
}
.telemetry-card {
  text-align: center;
}
</style>
